import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

/* Components */
import { CardArticleComponent } from './components/card-article/card-article.component';
import { SliderBannerComponent } from './components/slider-banner/slider-banner.component';
import { TwoWaySliderComponent } from './components/two-way-slider/two-way-slider.component';
import { HeaderComponent } from './layouts/header/header.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { TabSustainableComponent } from './components/tab-sustainable/tab-sustainable.component';
import { SubscribeComponent } from './components/subscribe/subscribe.component';
import { FundamentalComponent } from './components/fundamental/fundamental.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { WidgetDocumentsComponent } from './components/widget-documents/widget-documents.component';
import { WidgetShareholdingComponent } from './components/widget-shareholding/widget-shareholding.component';
import { DocsComponent } from './components/docs/docs.component';
import { BannerHeaderComponent } from './components/banner-header/banner-header.component';
import { TitlePageComponent } from './components/title-page/title-page.component';
import { PeoplePhotosComponent } from './components/people-photos/people-photos.component';
import { PeopleNophotosComponent } from './components/people-nophotos/people-nophotos.component';
import { WidgetPdfComponent } from './components/widget-pdf/widget-pdf.component';
import { CardAspectComponent } from './components/card-aspect/card-aspect.component';
import { VisionMisionComponent } from './components/vision-mision/vision-mision.component';
import { WidgetImageDetailComponent } from './components/widget-image-detail/widget-image-detail.component';

/* Pages */
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { ArticleDetailComponent } from './pages/article/article-detail/article-detail.component';
import { PageNotFoundComponent } from './auth/page-not-found/page-not-found.component';
import { ScrollComponent } from './components/scroll/scroll.component';
import { AboutComponent } from './pages/about/about.component';
import { InvestorComponent } from './pages/investor/investor.component';
import { AnnualReportComponent } from './pages/investor/annual-report/annual-report.component';
import { CompanyProfileComponent } from './pages/about/company-profile/company-profile.component';
import { VisionComponent } from './pages/about/vision/vision.component';
import { AddressOfficeComponent } from './pages/about/address-office/address-office.component';
import { CompanyAccessComponent } from './pages/about/company-access/company-access.component';
import { ArticleComponent } from './pages/article/article.component';
import { OrganiStructureComponent } from './pages/about/organi-structure/organi-structure.component';
import { GalleryPageComponent } from './pages/gallery-page/gallery-page.component';
import { SustainabilityComponent } from './pages/sustainability/sustainability.component';
import { SusMotionComponent } from './pages/sustainability/sus-motion/sus-motion.component';
import { SusPeopleComponent } from './pages/sustainability/sus-people/sus-people.component';
import { SusPlanetComponent } from './pages/sustainability/sus-planet/sus-planet.component';
import { SusProductComponent } from './pages/sustainability/sus-product/sus-product.component';
import { SusProfitComponent } from './pages/sustainability/sus-profit/sus-profit.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { PalmComponent } from './pages/product/palm/palm.component';
import { SriwijayaComponent } from './pages/product/sriwijaya/sriwijaya.component';
import { PrimaComponent } from './pages/product/prima/prima.component';
import { ProductComponent } from './pages/product/product.component';
import { CareerComponent } from './pages/career/career.component';
import { FinancialInformationComponent } from './pages/investor/financial-information/financial-information.component';
import { CorporateComponent } from './pages/corporate/corporate.component';
import { ComplianceComponent } from './pages/corporate/compliance/compliance.component';
import { CommitteeComponent } from './pages/corporate/committee/committee.component';
import { InvShareholdersComponent } from './pages/investor/inv-shareholders/inv-shareholders.component';
import { CompanyNewslettersComponent } from './pages/investor/company-newsletters/company-newsletters.component';
import { DisclosuresComponent } from './pages/investor/disclosures/disclosures.component';
import { ShareInformationComponent } from './pages/investor/share-information/share-information.component';
import { SubsidiariesComponent } from './pages/about/subsidiaries/subsidiaries.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { JobsComponent } from './pages/career/jobs/jobs.component';
import { FormCareerComponent } from './pages/career/form-career/form-career.component';
import { OtherProductComponent } from './pages/product/other-product/other-product.component';

/* Routing Module */
import { AppRoutingModule } from './app-routing.module';

/* Plugins */
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgSelect2Module } from 'ng-select2';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxFileDropModule } from 'ngx-file-drop';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SearchComponent } from './pages/search/search.component';
import { SubHeaderComponent } from './layouts/sub-header/sub-header.component';
import { LightboxModule } from 'ngx-lightbox';

@NgModule({
  declarations: [
    AppComponent,
    CardArticleComponent,
    HomeComponent,
    SliderBannerComponent,
    PageNotFoundComponent,
    ScrollComponent,
    TwoWaySliderComponent,
    HeaderComponent,
    FooterComponent,
    TabSustainableComponent,
    SubscribeComponent,
    FundamentalComponent,
    GalleryComponent,
    WidgetDocumentsComponent,
    WidgetShareholdingComponent,
    DocsComponent,
    BannerHeaderComponent,
    InvestorComponent,
    AnnualReportComponent,
    TitlePageComponent,
    AboutComponent,
    CompanyProfileComponent,
    VisionComponent,
    WidgetImageDetailComponent,
    AddressOfficeComponent,
    CompanyAccessComponent,
    OrganiStructureComponent,
    ArticleComponent,
    ArticleDetailComponent,
    PeoplePhotosComponent,
    PeopleNophotosComponent,
    GalleryPageComponent,
    SustainabilityComponent,
    SusMotionComponent,
    CardAspectComponent,
    SusPeopleComponent,
    SusPlanetComponent,
    SusProductComponent,
    SusProfitComponent,
    VisionMisionComponent,
    ContactUsComponent,
    CareerComponent,
    FinancialInformationComponent,
    PalmComponent,
    SriwijayaComponent,
    PrimaComponent,
    ProductComponent,
    WidgetPdfComponent,
    CorporateComponent,
    ComplianceComponent,
    CommitteeComponent,
    InvShareholdersComponent,
    CompanyNewslettersComponent,
    DisclosuresComponent,
    ShareInformationComponent,
    SubsidiariesComponent,
    SearchComponent,
    SubHeaderComponent,
    PrivacyComponent,
    JobsComponent,
    FormCareerComponent,
    OtherProductComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SlickCarouselModule,
    NgSelect2Module,
    AccordionModule.forRoot(),
    ModalModule.forRoot(),
    NgxFileDropModule,
    PerfectScrollbarModule,
    LightboxModule
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
